import { api } from '../../api/instance';

export const orderService = {
  convertCartToOrder() { return api.post('v3/orders/start', {}); },
  updateTimePeriods(districtId, date, periodId) {
    const payload = { district_id: districtId, date };
    if (periodId) payload.period_id = periodId;
    return api.post('v3/time_periods', payload);
  },
  updateCommonParams(orderFields) { return api.post('v3/orders/update_common_params', { order: orderFields }); },
  applyPromoCode(orderFields) { return api.post('v3/orders/apply_promo_code', { order: orderFields }); },
  makeOrder() { return api.post('v3/orders/make', {}); },
  payOrder(extra) { return api.post('v3/orders/pay', extra || {}); },
  payOrderJustPay() { return api.post('v3/orders/just_pay', {}); },
  getOrders() { return api.get('v3/orders/list'); },
  submitReview(payload) { return api.post('v3/orders/review', payload); },
  cancelOrder(orderId) { return api.post(`v3/orders/${orderId}/cancel`, {}); },
  changePayType(orderId, payTypeId) { return api.post(`v3/orders/${orderId}/pay_type`, { pay_type_id: payTypeId }); },
  payExistingOrder(orderId) { return api.post(`v3/orders/${orderId}/pay`, {}); },
  paidStatus(orderId) { return api.get(`v3/orders/${orderId}/paid_status`); },
  prepareRentAct() { return api.post('v3/rent_acts/checkout', {}); },
  signRentAct(id, code) { return api.post(`v3/rent_acts/${id}/sign`, code ? { code } : {}); },
  resendRentActCode(id) { return api.post(`v3/rent_acts/${id}/resend_code`, {}); },
  skipRentAct(id) { return api.post(`v3/rent_acts/${id}/skip`, {}); },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/orderStore/service.js